<template>
  <div style="height: auto;width: 100%;margin-top: 5px;" class="section cargo-advance-search query-bill-oversea-condition">
    <div v-show="showSimple" class="cargo-advance-search-header">
      <div class="cargo-advance-search-toggle-trigger">
        <i
          v-show="showAdv"
          class="el-icon-arrow-left"
          :style="{transform: !isShowingMoreSearchCondition?'rotate(-90deg)':'rotate(90deg)'}"
          @click="upOrDownSearchCondition"
        />
      </div>
      <div v-show="showSimple" class="cargo-advance-search-quick">
        <div style="width: 100%">
          <div class="form-column">
            <el-form
              label-position="left"
              :inline="true"
              label-width="75px"
            >
              <el-form-item :label="$t('CargoMsg.Cargo_BillNo')">
                <el-input v-model="filter.billingNo" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_DateType')">
                <div style="display: flex">
                  <el-select v-model="filter.dateType" style="width: 200px" :allow-create="true">
                    <el-option
                      v-for="(item,index) in arDateOption"
                      :key="index"
                      :label="item"
                      :value="item"
                    />
                  </el-select>
                  <el-date-picker
                    v-model="filter.minDate"
                    type="date"
                    style="width:122px;"
                    value-format="yyyy-MM-dd"
                  />
                  <span style="margin-right: 5px; margin-left: 5px;">{{ $t('Pricing.EndDate') }}</span>
                  <el-date-picker
                    v-model="filter.maxDate"
                    type="date"
                    style="width:122px;"
                    value-format="yyyy-MM-dd"
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_BillType')">
                <el-select
                  v-model="filter.billType"
                >
                  <el-option
                    v-for="(item,index) in ClearingConstants.BILLING_IS_AR_LIST"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AccountStatementNo')">
                <el-input v-model="filter.billingGroupNo" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SettlementAgent')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{settlementAgent:true}"
                  :default-value="filter.settlementAgent"
                  @parentCallBack="p=>{filter.settlementAgent=p.value}"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showAdv"
      v-show="isShowingMoreSearchCondition"
      class="cargo-advance-search-more"
    >
      <el-form label-width="75px" label-position="left" :inline="true" style="margin-left: 37px;">
        <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
          <el-input v-model="filter.jobNo" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_DestinationAgent')">
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{overseaAgent:true}"
            :default-value="filter.destinationAgent"
            @parentCallBack="p=>{filter.destinationAgent=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ChineseFirstVesselName')">
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_Vessel"
            :default-value="filter.vessel"
            tag-value="englishName"
            @parentCallBack="onVesselSelectionChange"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_VoyageNo')">
          <el-select
            v-model="filter.voyage"
            :allow-create="true"
          >
            <el-option
              v-for="(item,index) in voyageNos"
              :key="index"
              :label="item.voyageNo"
              :value="item.voyageNo"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <el-form label-width="75px" label-position="left" :inline="true" style="margin-left: 37px;">
        <el-form-item :label="$t('CargoMsg.Cargo_BusinessCategory')">
          <cargo-advance-select
            multiple
            :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
            :default-multiple-value="filter.lob"
            @parentCallBack="p=>{filter.lob=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_SettleAccountsTo')">
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{active:true}"
            :default-value="filter.accountId"
            @parentCallBack="p=>{filter.accountId=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_AmountRange')">
          <div style="display: flex">
            <el-input v-model="filter.amountMin" style="width: 84px;" />
            <span style="margin-right: 5px; margin-left: 5px;">{{ $t('CargoMsg.Cargo_To') }}</span>
            <el-input v-model="filter.amountMax" style="width: 84px;" />
          </div>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ConsolidateOrNot')">
          <el-checkbox v-model="filter.merge" />
        </el-form-item>
      </el-form>
      <el-form label-width="75px" label-position="left" :inline="true" style="margin-left: 37px;">
        <el-form-item :label="$t('CargoMsg.Cargo_BusinessStatus')">
          <el-select v-model="filter.jobState">
            <el-option
              v-for="(item,index) in jobStates"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_BranchCompany')">
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_Office"
            :callback-params="{key:'opOffice'}"
            callback-method-type="value"
            @parentCallBack="p=>{filter.opOffice=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Currency')">
          <el-select
            v-model="filter.currency"
          >
            <el-option
              v-for="(item,index) in ClearingConstants.CURRENCY_LIST_OPTION"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_WriteOffStatus')">
          <el-select
            v-model="filter.clearingState"
          >
            <el-option
              v-for="(item,index) in ClearingConstants.BILL_CLEARING_STATES"
              :key="index"
              :label="item.chineseName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div ref="searchOperations" class="cargo-advance-search-operations" style="margin-left: 27px;">
      <slot name="operations">
        <!--页面操作按钮-->
      </slot>
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import StrUtils from '@/utils/StrUtils'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { getVoyagesByVesselId } from '@/api/seaExport/seaExportJob'

export default {
  name: 'QueryBillOverseasAcceptCondition',
  components: {
    searchItem, cargoAdvanceSelect, cargoOfficeSelect
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    showSimple: { type: Boolean, default: true } // 显示简单UI查询
  },
  data() {
    return {
      URL,
      filter: {
        dateType: this.$t('CargoMsg.Cargo_BusinessDate'),
        billType: 'ALL',
        clearingState: '0',
        currency: 'ALL',
        jobState: 'ALL',
        accountId: 0,
        vessel: '',
        voyage: '',
        lob: []
      },
      selectTypeNames: TYPE_NAMES,
      ClearingConstants: ClearingConstants,
      voyageNos: [],
      arDateOption: [
        this.$t('CargoMsg.Cargo_BusinessDate'),
        this.$t('CargoMsg.Cargo_BillDate'),
        'ETD',
        'ETA'
      ],
      jobStates: [
        { label: this.$t('CargoMsg.Cargo_All'), value: 'ALL' },
        { label: this.$t('CargoMsg.Cargo_Approved'), value: '2' }
      ],
      isAdvancedQuery: false, // 是否为高级查询
      isShowingMoreSearchCondition: this.expandAdv,
      option: {},
      showDetail: false
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    },
    isShowingMoreSearchCondition(newVal) {
      this.$emit('advToggle', newVal)
    },
    'filter.allIn': function() {
      this.$emit('onGridRefresh')
    }
  },
  methods: {
    getSearchOption() {
      const option = {}
      const filter = this.filter
      // 业务编号
      if (!StrUtils.isEmpty(filter.jobNo)) {
        option['jobNo'] = filter.jobNo
      }

      // 结算对象
      if (filter.accountId > 0) {
        option['accountId'] = filter.accountId
      }

      // 账单类型
      if (filter.billType !== 'ALL') {
        if (filter.billType === 'Credit') {
          option['isAr'] = false
        } else if (filter.billType === 'Debit') { option['isAr'] = true }
      }
      // 币种
      if (!StrUtils.isEmpty(filter.currency) && filter.currency !== 'ALL') {
        option['currency'] = filter.currency
      }

      // 核销状态
      if (filter.clearingState !== 'ALL') {
        option['clearingState'] = filter.clearingState
      }

      // 账单号
      if (!StrUtils.isEmpty(filter.billingNo)) {
        option['billingNo'] = filter.billingNo
      }

      // 对账单号
      if (!StrUtils.isEmpty(filter.billingGroupNo)) {
        option['billingGroupNo'] = filter.billingGroupNo
      }

      // 结算代理
      if (filter.settlementAgent > 0) {
        option['settlementAgent'] = filter.settlementAgent
      }

      // 目的港代理
      if (filter.destinationAgent > 0) {
        option['destinationAgent'] = filter.destinationAgent
      }

      // 船名
      if (!StrUtils.isEmpty(filter.vessel)) {
        option['vessel'] = filter.vessel
      }

      // 航次
      if (!StrUtils.isEmpty(filter.voyage)) {
        option['voyage'] = filter.voyage
      }

      // 业务种类
      if (!StrUtils.isEmpty(filter.lob)) {
        option['jobLob'] = filter.lob
      }

      // 日期类型
      if (this.filter.minDate && this.filter.maxDate || this.filter.date) {
        option['dateType'] = this.getDateOption(option)
        option['minDate'] = this.filter.minDate
        option['maxDate'] = this.filter.maxDate
      }

      // 金额区间
      if (!StrUtils.isEmpty(filter.amountMin)) { option['amountMin'] = filter.amountMin }
      if (!StrUtils.isEmpty(filter.amountMax)) { option['amountMax'] = filter.amountMax }

      // 是否合并
      if (filter.merge) {
        option['isMerge'] = filter.merge
      }

      // 业务状态
      if (filter.jobState !== 'ALL') {
        option['jobState'] = Number(filter.jobState)
      }

      // 所属分公司
      if (!filter.opOffice && filter.opOffice !== 0) {
        option['branchId'] = filter.opOffice
      }

      option['state'] = Number(filter.submitState)

      return option
    },
    getDateOption() {
      const dateType = this.filter.dateType
      switch (dateType) {
        case 'ETD':
          return 'ETD'
        case 'ETA':
          return 'ETD'
        case this.$t('CargoMsg.Cargo_BillDate'):
          return 'inputDate'
        case this.$t('CargoMsg.Cargo_BusinessDate'):
          return 'businessDate'
      }
    },
    upOrDownSearchCondition() {
      this.isShowingMoreSearchCondition = !this.isShowingMoreSearchCondition
      this.isAdvancedQuery = this.isShowingMoreSearchCondition
      this.$emit('click-more', this.isShowingMoreSearchCondition)
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
    },
    resetSearch() {
      this.filter = PriceUtils.resetFilter(this.filter)
      this.filter = {
        dateType: this.$t('CargoMsg.Cargo_BusinessDate'),
        billType: 'ALL',
        clearingState: '0',
        currency: 'ALL',
        jobState: this.$t('CargoMsg.Cargo_All')
      }
    },
    changeCurrency(p) {
      this.filter.currency = p.value
      this.$emit('onGridRefresh')
    },
    // 根据船名查询航次
    onVesselSelectionChange(obj) {
      this.filter[obj.key] = obj.value
      this.filter.voyage = ''
      if (obj.value) {
        getVoyagesByVesselId(obj.vesselId).then(res => {
          this.voyageNos = res.data
        })
      } else {
        this.voyageNos = []
      }
    }
  }
}
</script>
<style lang="scss">
  .query-bill-oversea-condition{
    .cargo-advance-search-header{
      padding-bottom: 0px !important;
    }
    .el-input{
      width: 190px;
    }
    .el-form-item{
      margin-right: 30px;
      margin-bottom: 5px !important;
    }
  }
</style>
